/**
 * The periodic table, drawn: a sheet from the bottom in the survey, a panel
 * under the item in the player. Z, symbol and Ar on every cell; the name of
 * the one she clicks below the grid (in the player, on the line above it, so
 * the whole table fits under the item). In the player a click never takes
 * the focus off her slot, so she reads the table and goes on typing, and the
 * page does not move under her when it opens.
 */
import { useMemo, useState } from "react";

import { GROUP_HEADS, elements } from "./periodic";
import "./aids.css";

export function PeriodicTable({ close, inline = false }: { close: () => void; inline?: boolean }) {
  const cells = useMemo(elements, []);
  const [sel, setSel] = useState<number | null>(null);
  const c = cells.find((x) => x.z === sel);
  // in the player the focus stays in her answer: a mousedown here would move it
  const keep = inline ? { tabIndex: -1, onMouseDown: (e: React.MouseEvent) => e.preventDefault() } : {};
  const info = c && (
    <>
      <b>{c.sym}</b> – {c.name} · eilės numeris {c.z} · santykinė atominė masė {c.ar}
    </>
  );
  return (
    <div className={`pt ${inline ? "pt-inline" : "pt-sheet"}`} role={inline ? "region" : "dialog"} aria-label="Periodinė elementų lentelė" data-aid="periodic_table">
      {inline ? (
        <div className="pt-head">
          <span className="pt-info-inline">{info ?? <span className="pt-hint">Paspausk elementą – pamatysi pavadinimą.</span>}</span>
          <button className="quiet-link" type="button" onClick={close} {...keep}>
            Uždaryti <span className="key-hint">Esc</span>
          </button>
        </div>
      ) : (
        <div className="pt-head">
          <b>Periodinė elementų lentelė</b>
          <span className="pt-hint">Paspausk elementą – pamatysi pavadinimą.</span>
          <button className="btn btn-quiet btn-small" type="button" onClick={close}>
            Uždaryti
          </button>
        </div>
      )}
      <div className="pt-scroll">
        <div className="pt-grid">
          {GROUP_HEADS.map((h, i) => (
            <div key={h} className="pt-gh" style={{ gridColumn: i + 1, gridRow: 1 }}>
              {h.split(" ").map((x, k) => (
                <div key={k}>{x}</div>
              ))}
            </div>
          ))}
          {cells.map((e) => (
            <button key={e.z} type="button" className={`pt-el ${sel === e.z ? "sel" : ""}`} style={{ gridColumn: e.group, gridRow: e.period + 1 }} onClick={() => setSel(e.z)} {...keep}>
              <span className="z">{e.z}</span>
              <span className="s">{e.sym}</span>
              <span className="a">{e.ar}</span>
            </button>
          ))}
          <div className="pt-el ph2" style={{ gridColumn: 3, gridRow: 7 }}>
            57–71
          </div>
          <div className="pt-el ph2" style={{ gridColumn: 3, gridRow: 8 }}>
            89–103
          </div>
        </div>
      </div>
      {!inline && <div className="pt-info">{info}</div>}
    </div>
  );
}
